<template>
<section class="c-form">
    <simulation-banner v-if="!scenarioSelected"> </simulation-banner>
    <div v-else class="row">
        <div class="col-xs-12">
            <ul class="nav nav-tabs">
                <li
                    :class="{ 'active': index === active }"
                    v-for="(form, index) in forms"
                    v-bind:key="'head'+index">
                    <a @click="activate(index)" :href="'#' + customHref + '.' + form.url">
                        {{translate('Controls.' + form.title.replace(/ /g, ""), form.title)}}
                    </a>
                </li>
            </ul>

            </div>

            <div class="tab-content col-xs-12"
                v-for="(form, index) in forms"
                v-bind:key="'form'+index">
                <dynamicForm
                    v-bind="{form, active: (index === active) }"
                    @reload="reload"> </dynamicForm>
            </div>
        </div>
    </section>
</template>

<script>

    import dynamicForm from '@/components/form/dynamicForm.vue';
    import getPropertyValue from "../mixins/getPropertyValue";
    import formMap from "../data/formMap";
    import simulationBanner from "./simulationBanner";

    export default {
        name: 'ScenarioForms',
        components: {
            dynamicForm,
            simulationBanner
        },
        data : function (){
            return { // forms, entity
                forms: [],
                properties: [],
                active: 0,
                saveBtnState: "disabled",
                scenarioId: 1,
                scenarioName: 'Scénář 1'
            }
        },
        props: {
            customHref: String
        },
        methods: {
            async getEntities() {
                const simId = this.simulationId;
                return this.$store.dispatch('callApi', {
                    name: 'getEntities',
                    payload: {simId}
                });

            },
            async getProperties() {
                return this.$store.dispatch('callApi', {
                    name: 'getProperties'
                });
            },
            filterAndFill(type, entities){
                const filteredEntities = entities.filter((entity) => entity.type === type);
                this.fillForm(formMap[type], filteredEntities);
            },
            async loadEntities(){
                try{
                    const entities = await this.getEntities();
                    this.filterAndFill('zakladna', entities);
                    this.filterAndFill('vsk', entities);
                    this.filterAndFill('udalost', entities);
                    this.filterAndFill('nemocnice', entities);
                    this.filterAndFill('oddeleni', entities);
                    this.filterAndFill('predaniUdalosti', entities);
                } catch(e){
                    console.error(e);
                }
            },
            async loadProperties(){
                try{
                    const properties = await this.getProperties();
                    this.properties = properties;
                    for(const property of properties){
                        switch (property.linkType) {
                            case 'number':
                                this.applyNumberLinkToForm(property);
                                break;
                            case 'tag':
                                this.applyTagLinkToForm(property);
                                break;
                            case 'select':
                                this.applySelectLinkToForm(property);
                                break;
                        }
                    }
                } catch(e){
                    console.error(e);
                }
            },
            applyNumberLinkToForm({type, name, link}){
                if(!formMap.hasOwnProperty(type)){
                    return;
                }
                const form = formMap[type];
                /** @type Array */
                const properties = form.properties;
                const foundProperty = properties.find(prop=> prop.property === name);
                if(foundProperty !== undefined){
                    this.$set(foundProperty, 'type', 'select');
                    this.$set(foundProperty, 'extension', {options: this.getAllOfType(link)});
                    this.$set(foundProperty, 'linked', true);
                }
            },
            applyTagLinkToForm({type, name, link}){
                if(!formMap.hasOwnProperty(type)){
                    return;
                }
                const form = formMap[type];
                /** @type Array */
                const properties = form.properties;
                const foundProperty = properties.find(prop=> prop.property === name);
                if(foundProperty !== undefined){
                    this.$set(foundProperty, 'type', 'tag');
                    this.$set(foundProperty, 'extension', {options: this.getNamesOfType(link)});
                }
            },
            applySelectLinkToForm({type, name, extension}){
                if(!formMap.hasOwnProperty(type)){
                    return;
                }
                const form = formMap[type];
                /** @type Array */
                const properties = form.properties;
                let options;
                if(extension && Array.isArray(extension.options)){
                    options = extension.options.map((option) => {
                        if(typeof option === 'string'){
                            return {value: option, label: option};
                        } else {
                            return option;
                        }
                    })
                } else {
                    options = [];
                }
                const foundProperty = properties.find(prop=> prop.property === name);
                if(foundProperty !== undefined){
                    this.$set(foundProperty, 'type', 'select');
                    this.$set(foundProperty, 'extension', {options});
                }
            },
            getAllOfType(entityType){
                const form = this.forms.find(({type}) => type === entityType);
                return form.data.map((entity) => ({
                    value: entity.entityId,
                    label: this.findName(entity)
                }));
            },
            getNamesOfType(entityType){
                const form = this.forms.find(({type}) => type === entityType);

                return form.data.map((entity) => this.findName(entity));
            },
            findName(entity){
                const entityType = entity.type;
                const propertyDefinition = this.properties.find(({type, extension})=> {
                    const {label} = extension || {};
                    return type === entityType && label === 'name';
                });
                if(propertyDefinition) {
                    return getPropertyValue(entity, propertyDefinition.name);
                } else {
                    return entity.entityId;
                }
            },
            fillForm(formOptions, entities){
                for(const entity of entities){
                    entity.id = entity.entityId;
                }
                console.log(formOptions);
                const form = {
                    title: formOptions.title,
                    url: formOptions.url,
                    type: formOptions.type,
                    hideAddButton: formOptions.hideAddButton,
                    properties: formOptions.properties,
                    data: entities
                };
                this.$set(this.forms, Number(formOptions.index), form);
            },
            resetForm: function () {
                this.newItem = {};
            },
            splitData: function (response) {
                this.formScenar = response.data.forms;
                this.entity = response.data.entity;
                this.scenarioName = response.data.name;
            },
            activateBtn: function() {
                this.saveBtnState = "";
            },
            getSelectedValue: function(value,property) {
                if (!value) {
                    return '';
                }
                return property.options.find( (a) => {
                    return a.id==value;
                } ).text;
            },
            activate(index){
                console.log(`Activated ${index}`);
                this.active = index;
            },
            loadSubTab : function(fragment) {
                for (let form in this.forms) {
                    if (this.forms[form].url === fragment) {
                        this.activate(Number(form));
                        break;
                    }
                }
            },
            async reload(){
                await this.loadEntities();
                await this.loadProperties();
            }
        },
        computed: {
            scenarioSelected(){
                return this.$store.state.scenarioSelected;
            },
            simulationId(){
                if (this.$route.params.simId === undefined) {
                    return this.$store.state.simulation.properties.simId;
                } else {
                    return parseInt(this.$route.params.simId);
                }
            }
        },
        async mounted() {
            await this.reload();
            if (window.location.hash.includes('.')) {
                // Remove # and split fragment into tab names (separated by a dot)
                let  tabs = window.location.hash.slice(1, window.location.hash.length).split('.');
                if (tabs[1]) this.loadSubTab(tabs[1]);
            }
        }
    }
</script>

<style lang="less" scoped>
    .c-form {
        padding-top: 5px;
        max-width: 100%;
    }
</style>
